import http from './http'
import axios from 'axios'
import { getToken } from '../assets/js/auth'
import { Message } from 'element-ui'

var resquest = '';

if(process.env.NODE_ENV === 'development'){
    // 开发环境
	resquest = 'http://localhost:81/web/Supplier/';
}else{
    if(location.hostname == 'ebk.liuniu.cn'){
        // 测试环境
        resquest = 'https://admin.liuniu.cn/web/Supplier/';
    }else{
        // 生产环境
        resquest = 'https://17eu.cn/web/Supplier/';
	}
	
}

/**
 * 登录页「立即注册」跳转的 HotelApply 地址，与上方接口环境划分一致：
 * - 本地开发 (NODE_ENV=development) → 测试
 * - 测试站点 hostname === ebk.liuniu.cn → 测试
 * - 其它（正式部署）→ 正式
 */
export function getRegisterApplyUrl() {
    if (process.env.NODE_ENV === 'development') {
        return 'https://pc.liuniu.cn/HotelApply'
    }
    if (typeof location !== 'undefined' && location.hostname === 'ebk.liuniu.cn') {
        return 'https://pc.liuniu.cn/HotelApply'
    }
    return 'https://17eu.com/HotelApply'
}

const wxLoginHeaders = {
    'content-Type': 'application/x-www-form-urlencoded',
};

function postWxLogin(path, params) {
    return axios
        .post(`${resquest}${path}`, params, {
            headers: wxLoginHeaders,
            timeout: 10000,
        })
        .then((res) => res.data);
}

// get请求
export default {
    // 登录
    supplierLogin(params) {
        return http.post(`${resquest}Login/supplierLogin`, params)
    },
    supplierWxLogin(params) {
        return postWxLogin('Login/supplierWxLogin', params);
    },
    supplierWxSendSms(params) {
        return postWxLogin('Login/supplierWxSendSms', params);
    },
    supplierWxPhoneLogin(params) {
        return postWxLogin('Login/supplierWxPhoneLogin', params);
    },
    supplierSelectSupplier(params) {
        return http.post(`${resquest}Login/supplierSelectSupplier`, params);
    },
    supplierPrepareSwitch(params) {
        return http.post(`${resquest}Login/supplierPrepareSwitch`, params);
    },
    supplierSwitchToTuId(params) {
        return http.post(`${resquest}Login/supplierSwitchToTuId`, params);
    },
    orderLinkSupplierHint(params) {
        return http.post(`${resquest}Login/orderLinkSupplierHint`, params);
    },
    orderLinkContext(params) {
        return http.post(`${resquest}Platform/orderLinkContext`, params);
    },
    // 修改密码
    changeSupplierPassword(params) {
        return http.post(`${resquest}Login/changeSupplierPassword`, params)
    },

    // 查询国家
    countryQueryData(params) {
        return http.post(`${resquest}BaiduApi/countryQueryData`, params)
    },
    // 查询城市
    cityQueryData(params) {
        return http.post(`${resquest}BaiduApi/cityQueryData`, params)
    },
    // 查询酒店品牌
    brandQueryData(params) {
        return http.post(`${resquest}Hotel/brandQueryData`, params)
    },
    // 查询搜索等级
    gradeQueryData(params) {
        return http.post(`${resquest}Hotel/gradeQueryData`, params)
    },
    // 搜索酒店政策
    policyQueryData(params) {
        return http.post(`${resquest}Hotel/policyQueryData`, params)
    },

    // 获取酒店列表
    hotelList(params) {
        return http.post(`${resquest}Hotel/hotelList`, params)
    },

    // 获取母酒店列表
    showHotelList(params) {
        return http.post(`${resquest}Hotel/showHotelList`, params)
    },

    // 母酒店智能/艺龙/Sphinx 检索（新增酒店弹窗）
    searchBaseHotel(params) {
        return http.post(`${resquest}Hotel/searchBaseHotel`, params)
    },

    // 添加并匹配酒店,修改 酒店
    editMatchingHotel(params) {
        return http.post(`${resquest}Hotel/editMatchingHotel`, params)
    },

    // 删除酒店
    deleteHotel(params) {
        return http.post(`${resquest}Hotel/deleteHotel`, params)
    },

    // 基础房型列表
    proShowBaseList(params) {
        return http.post(`${resquest}Hotel/proShowBaseList`, params)
    },

    // 酒店详情 获取房型 政策 价格
    HotelDetail(params) {
        return http.post(`${resquest}Hotel/HotelDetail`, params)
    },

    // 酒店房型列表
    proBaseList(params) {
        return http.post(`${resquest}Hotel/proBaseList`, params)
    },

    // 新增并匹配，编辑房型
    editMatchingProBase(params) {
        return http.post(`${resquest}Hotel/editMatchingProBase`, params)
    },

    // 房型政策列表
    proBasePolicy(params) {
        return http.post(`${resquest}Hotel/proBasePolicy`, params)
    },

    // 添加、编辑房型政策
    editProBasePolicy(params) {
        return http.post(`${resquest}Hotel/editProBasePolicy`, params)
    },

    // 按月份批量修改底价
    editEveryPriceSomeMonth(params) {
        return http.post(`${resquest}Hotel/editEveryPriceSomeMonth`, params)
    },

    // 按星期批量修改底价
    editEveryPriceSomeWeek(params) {
        return http.post(`${resquest}Hotel/editEveryPriceSomeWeek`, params)
    },

    // 获取底价
    getEveryPriceStock(params) {
        return http.post(`${resquest}Hotel/getEveryPriceStock`, params)
    },

    // 修改底价
    editEveryPrice(params) {
        return http.post(`${resquest}Hotel/editEveryPrice`, params)
    },

    // 获取对应酒店的库存
    getStock(params) {
        return http.post(`${resquest}Hotel/getStock`, params)
    },

    // 按月份批量修改库存
    editEveryStockSomeMonth(params) {
        return http.post(`${resquest}Hotel/editEveryStockSomeMonth`, params)
    },

    // 按星期批量修改库存
    editEveryStockSomeWeek(params) {
        return http.post(`${resquest}Hotel/editEveryStockSomeWeek`, params)
    },

    // 修改库存状态
    editEveryStock(params) {
        return http.post(`${resquest}Hotel/editEveryStock`, params)
    },

    // 获得酒店销售订单主表信息列表
    sobillList(params) {
        return http.post(`${resquest}Platform/sobillList`, params)
    },

    // 获得销售订单的明细信息
    soBillDetailList(params) {
        return http.post(`${resquest}Platform/soBillDetailList`, params)
    },

    // 订单确认
    commitSOBill(params) {
        return http.post(`${resquest}Platform/commitSOBill`, params)
    },

    // 订单取消确认
    cancelConfirmSOBill(params) {
        return http.post(`${resquest}Platform/cancelConfirmSOBill`, params)
    },

    // 查询销售订单旅客信息
    soBillWSBillList(params) {
        return http.post(`${resquest}Platform/soBillWSBillList`, params)
    },
    // 订单业务日志（供应商平台）
    getOrderLog(params) {
        return http.post(`${resquest}Platform/getOrderLog`, params)
    },
    // 查询行程信息
    soBillLineList(params) {
        return http.post(`${resquest}Platform/soBillLineList`, params)
    },

    // 获取酒店日志
    getResLog(params) {
        return http.post(`${resquest}Bizlog/getResLog`, params)
    },

    // 待确认销售订单提醒数量
    soPendingList(params) {
        return http.post(`${resquest}Platform/soPendingList`, params)
    },

    // 修改对单号
    confirmationNumberEdit(params) {
        return http.post(`${resquest}Platform/confirmationNumberEdit`, params)
    },

    // 修改酒店确认号
    psmNoEdit(params) {
        return http.post(`${resquest}Platform/psmNoEdit`, params)
    },

    // 确认取消订单
    confirmationCancelEdit(params) {
        return http.post(`${resquest}Platform/confirmationCancelEdit`, params)
    },

    // 修改酒店备注
    edidRemarks(params) {
        return http.post(`${resquest}Hotel/edidRemarks`, params)
    },
    // 结算申请的列表
    payRvDetailList(params) {
        return http.post(`${resquest}Platform/payRvDetailList`, params)
    },
    // 结算申请的列表
    auditRecordList(params) {
        return http.post(`${resquest}Platform/auditRecordList`, params)
    },
    //提交结算申请（multipart，含发票）
    someDingAddPayRvmentMultipart(formData) {
        let token = ''
        let code = ''
        if (getToken('userInfo')) {
            const userInfo = JSON.parse(getToken('userInfo'))
            token = userInfo.token
            code = userInfo.code
        }
        const headers = {}
        if (token) headers.token = token
        if (code) headers['X-Remote-User'] = code
        return axios
            .post(`${resquest}Platform/someDingAddPayRvment`, formData, {
                headers,
                timeout: 120000,
            })
            .then((res) => {
                const data = res.data
                if (data && data.success) {
                    return data
                }
                Message.error((data && data.msg) || '请求失败')
                return Promise.reject(data || { success: false })
            })
            .catch((err) => {
                if (!err || err.success === undefined) {
                    const d = err && err.response && err.response.data
                    if (d && d.msg) {
                        Message.error(d.msg)
                    } else if (!axios.isCancel(err)) {
                        Message.error('网络异常，请稍后重试')
                    }
                }
                return Promise.reject(err)
            })
    },
    //结算申请详情
    rvPayDetailList(params){
        return http.post(`${resquest}Platform/rvPayDetailList`, params)
    },
    /** 结算列表：查看当前供应商 AUTO_TRANS 结算配置 */
    supplierAutoTransSetting(params) {
        return http.post(`${resquest}Platform/supplierAutoTransSetting`, params)
    },
    /** 结算申请：购买方 + 销售方（开票方）展示 */
    settlementInvoiceParties(params) {
        return http.post(`${resquest}Platform/settlementInvoiceParties`, params)
    }

}





// WEBPACK FOOTER //
// ./src/api/api.js